import { makeStyles } from "@material-ui/core";
import { green } from "@material-ui/core/colors";

const useMessagesListStyles = makeStyles((theme) => ({
  messagesListWrapper: {
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    width: "100%",
    minWidth: 300,
    minHeight: 200,
  },

  messagesList: {
    backgroundColor: theme.palette.messageBackground || (theme.mode === 'dark' ? "#111827" : "#f5f5f5"), // ✅ USA TEMA
    backgroundImage: "none",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "20px 20px 20px 20px",
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },

  circleLoading: {
    color: green[500],
    position: "absolute",
    opacity: "70%",
    top: 0,
    left: "50%",
    marginTop: 12,
  },

  messageLeft: {
    marginRight: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    whiteSpace: "pre-wrap",
    backgroundColor: theme.palette.messageLeftBg || (theme.mode === 'dark' ? "#1e40af" : "#93c5fd"), // ✅ USA TEMA
    color: theme.palette.messageLeftText || (theme.mode === 'dark' ? "#ffffff" : "#000000"), // ✅ USA TEMA
    alignSelf: "flex-start",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "0px",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 8,
    paddingBottom: 4,
    boxShadow: theme.mode === 'dark' ? "0 1px 2px rgba(0, 0, 0, 0.5)" : "0 1px 1px #b3b3b3", // ✅ USA TEMA
    "&:hover $messageActionsButton": {
      opacity: 1,
      visibility: "visible",
    },
  },

  quotedContainerLeft: {
    margin: "-3px -80px 6px -6px",
    overflow: "hidden",
    backgroundColor: theme.palette.quotedLeftBg || (theme.mode === 'dark' ? "#374151" : "#f0f0f0"), // ✅ USA TEMA
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsg: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  quotedSideColorLeft: {
    flex: "none",
    width: "4px",
    backgroundColor: theme.palette.quotedSideLeft || (theme.mode === 'dark' ? "#3b82f6" : "#6bcbef"), // ✅ USA TEMA
  },

  messageRight: {
    marginLeft: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    whiteSpace: "pre-wrap",
    backgroundColor: theme.palette.messageRightBg || (theme.mode === 'dark' ? "#059669" : "#6ee7b7"), // ✅ USA TEMA
    color: theme.palette.messageRightText || (theme.mode === 'dark' ? "#ffffff" : "#000000"), // ✅ USA TEMA
    alignSelf: "flex-end",
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "4px",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 8,
    paddingBottom: 4,
    boxShadow: theme.mode === 'dark' ? "0 1px 2px rgba(0, 0, 0, 0.5)" : "0 1px 1px #b3b3b3", // ✅ USA TEMA
    "&:hover $messageActionsButton": {
      opacity: 1,
      visibility: "visible",
    },
  },

  quotedContainerRight: {
    margin: "-3px -80px 6px -6px",
    overflowY: "hidden",
    backgroundColor: theme.palette.quotedRightBg || (theme.mode === 'dark' ? "#065f46" : "#cfe9ba"), // ✅ USA TEMA
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsgRight: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    whiteSpace: "pre-wrap",
  },

  quotedSideColorRight: {
    flex: "none",
    width: "4px",
    backgroundColor: theme.palette.quotedSideRight || (theme.mode === 'dark' ? "#10b981" : "#35cd96"), // ✅ USA TEMA
  },

  messageActionsButton: {
    display: "block", // ✅ CAMBIAR DE "none" A "block"
    position: "absolute", // ✅ CAMBIAR DE "relative" A "absolute"
    color: "#ffffff",
    zIndex: 10,
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    top: "4px",
    right: "4px",
    padding: "4px",
    fontSize: "14px",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    opacity: "90%",
    "&:hover, &.Mui-focusVisible": {
      backgroundColor: "rgba(0, 0, 0, 0.5)"
    },
  },

  messageContactName: {
    display: "block",
    fontSize: "12.8px",
    fontWeight: 500,
    marginBottom: "4px",
    lineHeight: "22px",
    // El color se aplicará dinámicamente por remitente
  },

  textContentItem: {
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },

  textContentItemEdited: {
    overflowWrap: "break-word",
    padding: "3px 120px 6px 6px",
  },

  textContentItemDeleted: {
    fontStyle: "italic",
    color: theme.palette.messageDeletedText || (theme.mode === 'dark' ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.36)"), // ✅ USA TEMA
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },
  forwardMessage: {
    fontSize: 12,
    fontStyle: "italic",
    position: "absolute",
    top: 0,
    left: 5,
    color: theme.palette.forwardMessageColor || (theme.mode === 'dark' ? "#9ca3af" : "#999"), // ✅ USA TEMA
    display: "flex",
    alignItems: "center"
  },
  messageMedia: {
    objectFit: "cover",
    width: 250,
    height: 200,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },

  timestamp: {
    fontSize: 11,
    position: "absolute",
    bottom: 0,
    right: 5,
    color: theme.mode === 'dark' ? "#ffffff" : "#ffffff", // ✅ USA TEMA - Blanco funciona en ambos modos con los nuevos fondos
    display: "flex",
    alignItems: "center",
  },

  dailyTimestamp: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "110px",
    backgroundColor: theme.palette.dailyTimestampBg || (theme.mode === 'dark' ? "#1f2937" : "#e1f3fb"), // ✅ USA TEMA
    margin: "10px",
    borderRadius: "10px",
    boxShadow: theme.mode === 'dark' ? "0 1px 2px rgba(0, 0, 0, 0.5)" : "0 1px 1px #b3b3b3", // ✅ USA TEMA
  },

  dailyTimestampText: {
    color: theme.palette.dailyTimestampText || (theme.mode === 'dark' ? "#9ca3af" : "#808888"), // ✅ USA TEMA
    padding: 8,
    alignSelf: "center",
    marginLeft: "0px",
  },

  ackIcons: {
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  deletedIcon: {
    fontSize: 18,
    verticalAlign: "middle",
    marginRight: 4,
  },

  ackDoneAllIcon: {
    color: green[500],
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  downloadMedia: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "inherit",
    padding: 10,
  },
}));

export default useMessagesListStyles;
